// @flow
import * as React from 'react';
import UserGeneratedTextContainer from 'components/ContentSection/UserGeneratedTextContainer';
import { AuthorInfo } from './AuthorInfo';
import MediaViewer from '../MediaViewer';
import type { Answer, Question } from 'models';
import './QAComponents.scss';
import { useContentCard } from 'context/content-card-context';

export const Icon = ({ ugctype }: { ugctype: UgcType }) => {
  const char =
    ugctype === 'WDYB' || ugctype === 'Answer' ? 'A' : ugctype.charAt(0);

  return <abbr className="QA-Icon bg-dark-gray white">{char}</abbr>;
};

export const ArticleContainer = (props: {
  ugctype: UgcType,
  main: React.Node,
  aside?: ?React.Node,
}) => {
  const { ugctype, main, aside } = props;

  return (
    <section className="QA-Article">
      <div className="QA-Article__LeftAside mr3 pt1">
        <Icon ugctype={ugctype} />
      </div>
      <div className="QA-Article__Main">{main}</div>
      {aside && <div className="QA-Article__RightAside">{aside}</div>}
    </section>
  );
};

export const Article = (props: {
  ugc: Answer | Question,
  aside?: React.Node,
}) => {
  const { ugc, aside } = props;
  const { isClientCard } = useContentCard();
  const text = ugc.ugc_archetype === 'Question' ? ugc.question : ugc.answer;
  const main = (
    <React.Fragment>
      <h1 className="mt0 mb1 QA-Text">
        <UserGeneratedTextContainer
          data-key={ugc.ugctype.toLowerCase()}
          text={text}
        />
      </h1>
      <AuthorInfo ugc={ugc} />
      {isClientCard && (
        <div className="mv2" key="media">
          <MediaViewer ugcs={ugc.getMedia()} hideUgcLink={true} />
        </div>
      )}
    </React.Fragment>
  );

  return (
    <ArticleContainer ugctype={ugc.ugc_archetype} main={main} aside={aside} />
  );
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/QAComponents.js